import { useCallback, useState } from 'react';

import useGeneratikTableStore from '@/shared/ui/GeneratikTable/generatikTableStore';

import { clampZoom } from './zoom';

export interface UseTableZoomReturn {
  level: number;
  setLevel: (next: number) => void;
}

export default function useTableZoom(widthKey: string | null): UseTableZoomReturn {
  const storeLevel = useGeneratikTableStore((s) => (widthKey ? (s.zoomLevels[widthKey] ?? 0) : 0));
  const setStoreLevel = useGeneratikTableStore((s) => s.setZoomLevel);
  const [localLevel, setLocalLevel] = useState(0);

  const level = widthKey ? storeLevel : localLevel;

  const setLevel = useCallback(
    (next: number) => {
      const clamped = clampZoom(next);
      if (widthKey) setStoreLevel(widthKey, clamped);
      else setLocalLevel(clamped);
    },
    [widthKey, setStoreLevel],
  );

  return { level, setLevel };
}
